<h2 mat-dialog-title>Förslag för aspektgrupp {{ reportAspectGroupName }}</h2>
<form [formGroup]="proposalForm" (ngSubmit)="save(true)">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      @if (loadingIndicator) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      }

      <div formArrayName="proposals" class="fullWidth">
        <mat-accordion [multi]="false" >
          @for (proposal of proposalsArray.controls; track proposal; let idx = $index) {
            <mat-expansion-panel #expansionPanel [hideToggle]="true" [formGroupName]="idx" [expanded]="selectedIndex == idx">
              <mat-expansion-panel-header>
                <div [ngClass]="proposal.get('details').hasError('required') ? 'flex-1 error' : 'flex-1'">{{ getProposalTitle(idx, proposal) }}</div>
                @if (hasPermissionToChange$ | async) {
                  <div class="flex-170px">
                    <button mat-icon-button type="button" matTooltip="Flytta upp" [disabled]="idx == 0" (click)='moveUp($event, idx)'><mat-icon>arrow_upward</mat-icon></button>
                    <button mat-icon-button type="button" matTooltip="Flytta ned" [disabled]="idx == proposalsArray.controls.length-1" (click)='moveDown($event, idx)'><mat-icon>arrow_downward</mat-icon></button>
                    <button mat-icon-button type="button" matTooltip="Lägg till" (click)='add(expansionPanel, $event, idx)'><mat-icon>add</mat-icon></button>
                  </div>
                }
              </mat-expansion-panel-header>
              <div class="flex-col gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Detaljer</mat-label>
                  <textarea rows="10" matInput formControlName="details" required></textarea>
                  @if (proposal.get('details').hasError('required')) {
                    <mat-error>Detaljer måste anges till förslag {{ idx + 1 }}</mat-error>
                  }
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Kommentar</mat-label>
                  <textarea rows="2" matInput formControlName="comment"></textarea>
                </mat-form-field>
              </div>
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <div class="flex-1"><mat-checkbox formControlName="notApplicable">Ej tillämpligt</mat-checkbox></div>
                <div class="flex-1"><mat-checkbox formControlName="fixed">Åtgärdat</mat-checkbox></div>
                <div class="flex-1"><mat-checkbox formControlName="fromPreviousReport" [disabled]="true">Från föregående rapport</mat-checkbox></div>
              </div>
              @if (proposal.get('fromPreviousReport').value) {
                <div class="flex-row flex-col-ltmd gap-col-1em">
                  <mat-form-field class="flex-1">
                    <mat-label>Ursprungsdatum</mat-label>
                    <input matInput value="{{ proposal.get('originalDate').value | dateFormatter:false }}" [readonly] />
                  </mat-form-field>
                </div>
              }
              <mat-action-row>
                @if (hasPermissionToChange$ | async) {
                  <button mat-button type="button" color="warn" (click)='remove($event, idx)'>{{ 'commands.Delete' | translate }}</button>
                }
              </mat-action-row>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (hasPermissionToChange$ |async) {
      <button mat-raised-button type="submit" color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
    }
    @if (hasPermissionToChange$ |async) {
      <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
    }
    <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
    @if (proposalsArray.controls.length == 0 && hasPermissionToChange$ | async) {
      <button mat-raised-button type="button" (click)="add(null, $event, 0)">{{ 'commands.Add' | translate }}</button>
    }
  </mat-dialog-actions>
</form>
